/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![PinUprightSlashIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAABX0lEQVR4nL2Uv0rEQBCHIypWdt6riF0KRVNkZ8ZiM5NShVM7H0DsrXwZEQ47sbW4wlJtbGwV4QTvD3NcwqG57G4M/mBIIMz3TXY3iaL/jkF+A5JxSBmUrzTNN7Rfr4DSA+LLagHJYxichwb5qIQT96fPUHqVAsT8OEAwMsSn2pdY2ynhxP3ijaqyZFDOAPmp0eQO+K/AgsmB5CR0cl/BqDV4haBd+A9B+3Czn20VGwokh3/e0PmklMeG5N0H3u12VwPhvAskn1M4ZAd1cD2qBuVDe7zgiNkekAz84Tyc7dFAe50CQ/LSAD6e1bNb0Bw+1nIKiPLNOnhibUf/npW/D5I7p6CAtHIUq7JockRmQ3KrBcRXUZPUfUQG+bpcDpSbYLhrWYD4Ym69z1uFawCynUKQIm9HvrHWLgPKg2tDAWDdoHxr6b23IEmSNSB5VYnrtADKvZY3fF4Sx/FKcKNHJlOnqK3NGjV7AAAAAElFTkSuQmCC)
 */
export const PinUprightSlashIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M22.7 2.7a1 1 0 0 0-1.4-1.4l-20 20a1 1 0 1 0 1.4 1.4l20-20ZM4.5 1h13.17a.5.5 0 0 1 .36.85L4.62 15.25c-.2.22-.56.2-.6-.1A1 1 0 0 1 4 15v-.95a2 2 0 0 1 .61-1.44L8 9.35V5h-.91C5.39 5 4 3.48 4 1.6v-.1c0-.28.22-.5.5-.5ZM17.77 11.05a.5.5 0 0 0-.7 0l-4.1 4.1a.5.5 0 0 0 .36.85H19a1 1 0 0 0 1-1v-.95a2 2 0 0 0-.61-1.44l-1.62-1.56ZM11.08 17.25a.5.5 0 0 0-.36.15l-.36.37a.5.5 0 0 0-.14.46l.99 4.38a.5.5 0 0 0 .49.39h.6a.5.5 0 0 0 .49-.39l1.07-4.75a.5.5 0 0 0-.49-.61h-2.3Z"
        className={colorClass}
      />
    </svg>
  );
};
